<template>
  <div>
    <span v-for="(product_type, index) in product_set.product_types" :key="index">
      <create-content
        :modal_id="'modal-process-v2-' + lot_id"
        :lot="lot"
        :lot_id="lot_id"
        :product_type="product_type"
        :product_id="product_id"
        :net_kilograms_sum_in="net_kilograms_sum_in"
        :net_kilograms_sum_out="net_kilograms_sum_out"
        :productSet="product_set"
      ></create-content>
    </span>
  </div>
</template>

<script>
import CreateContent from "@/views/proceso-v2-alfa/CreateContent";
export default {
  name: "CreateContentButtons",
  components: {
    CreateContent
  },
  props: {
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: "0"
    },
    net_kilograms_sum_out: {
      type: String,
      default: "0"
    },
    lot_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      product_set: {
        containers: [],
        exportable_containers: [],
        product_types: [],
        spec_type: [],
        varieties: []
      },
      loading: true
    };
  },
  watch: {
    product_id(n_val) {
      if (n_val) {
        this.getProductSet(this.product_id);
      }
    }
  },
  mounted() {
    console.log("CreateContentButtons mounted");
    this.getProductSet(this.product_id);
    this.getProductTypesByProcessType(this.$route.params.id);
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    // Exclude 'Granel' from product types
    async getProductSet(a) {
      const thisV = this;
      try {
        const res = await this.$axios.get("/production/get_product_set/" + a);
        thisV.product_set.containers = res.data.containers;
        thisV.product_set.exportable_containers = res.data.exportable_containers;
        thisV.product_set.spec_type = res.data.spec_type;
        thisV.product_set.varieties = res.data.varieties;
        thisV.product_set.bulk_containers = res.data.bulk_containers;
        thisV.product_set.export_custom_fields = res.data.export_custom_fields;
      } catch (error) {
        thisV.$toast.error("Ocurrio un error al cargar datos", "");
        console.log(error);
      }
    },
    async getProductTypesByProcessType(process_id) {
      const thisV = this;
      try {
        const res = await this.$axios.get("/production/process_allowed_product_types/" + process_id);
        thisV.product_set.product_types = res.data.product_types;
      } catch (error) {
        thisV.$toast.error("Ocurrio un error al cargar datos", "");
        console.log(error);
      }
    }
  }
};
</script>

<style scoped></style>
